import {store} from "../app/store.js";
import {api} from "../app/api.js";
import {router} from "../app/app.js";
import {display_errors} from "../helpers/forms.js";
import { refresh_auth_token } from "../app/api.js";

export default {
    template: `
        <div>
            <h1>Subscriptions</h1>
            
            <div id="Plans" class="subscription-plans">
                <div class="plan">
                    <h3>VOD</h3>
                    <p class="cost"><span class="amount">&pound;5</span> / month</p>
                  
                    <div class="content">
                        <p>What's included?</p>
                        
                        <p class="item"><i class="fas fa-rectangle-video-on-demand"></i><span>Listen to past radio shows</span></p>
                    </div>
                    
                    <button class="subscribe" data-plan_id="1">Next</button>
                </div>
                                
                <div class="plan hidden">
                    <h3>VIP</h3>
                    <p class="cost"><span class="amount">&pound;10</span> / month</p>
                  
                    <div class="content">
                        <p>What's included:</p>
                        <p class="item"><i class="fas fa-rectangle-video-on-demand"></i><span>Listen to past radio shows</span></p>
                        <p class="item"><i class="fas fa-badge-dollar"></i><span>VIP releases are FREE!</span></p>
                    </div>
                    <button class="subscribe" data-plan_id="2">Next</button>
                </div>
            </div>
            
            <div id="PaymentSections" class="hidden">
                <div id="Payment" class="container hidden">
                    <h2>Payment Details</h2>
                    
                    <p>Start Date: Today</p>
                    <p>Cost: £5 /month</p>
                    
                    <div id="PaymentRequestButton"></div>
    
                    <!-- Divider -->
                    <div id="PaymentMethodDivider" class="hidden" style="text-align:center; margin: 1em 0;">or pay with card</div>
        
                    <!-- Card form -->
                    <form id="PaymentForm" class="form">
        
                        <div class="input">
                            <label for="CardholderName">Cardholder's Name</label>
                            <input type="text" id="CardholderName" name="cardholder_name" autocomplete="off"/>
                        </div>
        
                        <div class="input">
                            <span class="label">Payment Card</span>
                            <div id="PaymentCardElement" class="stripe-element"></div>
                        </div>
                        
                        <p>By Signing up you are agreeing to our Subscriptions policies within our <a href="/terms">Terms and Conditions</a></p>
                        
                        <button id="PaymentSubmit" type="submit">Sign Up</button>
                        <div id="PaymentErrors" class="errors hidden"></div>
                    </form>
                </div>
                
                <div id="Processing" class="container hidden">
                    <h1>Processing</h1>
        
                    <div class="content">
                        <p class="center">Please wait while we process your payment and activate your subscription.</p>
                    </div>
                </div>
                
                <div id="Completed" class="container hidden">
                    <h2>Payment Successful</h2>
                    <div class="content">
                        <p class="center">Your subscription has been activated.</p>
                    </div>
                </div>
                
                <div id="Error" class="container hidden">
                    <h2>Something's gone wrong...</h1>
        
                    <p class="message center">
                        Unfortunately, something isn't working correctly.</br>
                        </br>
                        Please try refreshing and try again.<br/>
                        If the problem persists, please contact us.<br/>
                        <br/>
                        <a class="highlight" href="mailto:support@kingearthquake.uk">support@kingearthquake.uk</a>
                    </p>
                </div>
            </div>
        </div>
    `,

    confirm_subscription(data, setupIntent) {
        api.post({
            url: '/subscriptions/complete',
            data: {
                plan_id: data.plan_id,
                payment_method_id: setupIntent.payment_method,
            },
            success: () => {
                this.$processing.classList.add('hidden');
                this.$completed.classList.remove('hidden');

                refresh_auth_token();
            },
            error: (response) => {
                if (this.$errors) {
                    display_errors(this.$errors, response);
                } else {
                    this.$payment_errors.textContent = 'Failed to create subscription. Please try again.';
                }

                this.$processing.classList.add('hidden');
                this.$payment_errors.classList.remove('hidden');
                this.$payment.classList.remove('hidden');
            }
        });
    },

    async load_stripe(data) {
        const stripe = Stripe(data.stripe_publishable_key);
        const elements = stripe.elements();

        const style = {
            base: {
                color: '#ededf1',
                fontSize: '16px',
                fontFamily: '"Poppins", sans-serif',
                '::placeholder': {
                    color: '#888',
                },
            },
            invalid: {
                color: '#ff4d4f',
                iconColor: '#ff4d4f',
            },
        };

        const card_element = elements.create("card", { style });
        card_element.mount("#PaymentCardElement");
        this.$payment_card = card_element;

        // Create Payment Request for Google Pay, Apple Pay, etc.
        this.paymentRequest = stripe.paymentRequest({
            country: 'GB',
            currency: 'gbp',
            total: {
                label: 'Subscription',
                amount: 0,
            },
            requestPayerName: true,
            requestPayerEmail: true,
        });

        const prButton = elements.create('paymentRequestButton', {
            paymentRequest: this.paymentRequest,
        });

        // Check if Payment Request is available (Google Pay, Apple Pay, etc.)
        const result = await this.paymentRequest.canMakePayment();
        if (result) {
            prButton.mount('#PaymentRequestButton');
            document.getElementById('PaymentMethodDivider').classList.remove('hidden');
        }


        this._boundSubmitPaymentRequest = async (event) => {
            this.$payment.classList.add('hidden');
            this.$processing.classList.remove('hidden');

            const { setupIntent, error } = await stripe.confirmCardSetup(
                data.client_secret,
                {
                    payment_method: event.paymentMethod.id,
                },
                { handleActions: false }
            );

            if (error) {
                event.complete('fail');

                this.$payment_errors.textContent = error.message;
                this.$payment_errors.classList.remove('hidden');
                this.$processing.classList.add('hidden');
                this.$payment.classList.remove('hidden');
            } else if (setupIntent.status === 'succeeded') {
                event.complete('success');
                this.confirm_subscription(data, setupIntent);
            }
        }


        this._boundSubmitPaymentForm = async (event) => {
            event.preventDefault();

            this.$payment.classList.add('hidden');
            this.$processing.classList.remove('hidden');

            const { setupIntent, error } = await stripe.confirmCardSetup(data.client_secret, {
                payment_method: {
                    card: card_element,
                    billing_details: {
                        email: data.email,
                        name: this.$payment_form.cardholder_name.value,
                    }
                }
            });

            if (error) {
                this.$payment_errors.textContent = error.message;
                this.$payment_errors.classList.remove('hidden');
                this.$processing.classList.add('hidden');
                this.$payment.classList.remove('hidden');
            } else if (setupIntent.status === 'succeeded') {
                this.confirm_subscription(data, setupIntent);
            }
        };

        this.paymentRequest.on('paymentmethod', this._boundSubmitPaymentRequest);
        this.$payment_form.addEventListener('submit', this._boundSubmitPaymentForm);

        this.$payment_form.cardholder_name.value = data.cardholder_name;
    },

    subscribe(event) {
        const plan_id = parseInt(event.target.getAttribute('data-plan_id'));

        if (!store.get('auth')?.logged_in) {
            router.navigate('/register?redirect=/subscriptions?p=' + plan_id);
            return;
        }

        api.post({
            url: '/subscriptions/subscribe',
            data: {
                plan_id: plan_id
            },
            success: (response) => {
                response.plan_id = plan_id

                this.load_stripe(response);

                this.$plans.classList.add('hidden');
                this.$payment.classList.remove('hidden');
                document.getElementById('PaymentSections').classList.remove('hidden');
            },
            error: (response) => {
                if (response.errors && response.errors.common) {
                    this.$error.querySelector('.message').textContent = response.errors.common;
                }

                this.$error.classList.remove('hidden');

                this.$plans.classList.add('hidden');
                document.getElementById('PaymentSections').classList.remove('hidden');
            }
        });
    },

    $plans: null,
    $payment: null,
    $processing: null,
    $completed: null,
    $error: null,

    $payment_form: null,
    $payment_card: null,
    $payment_errors: null,

    stripe_subscription_id: null,
    stripe_secret: null,
    payment_request: null,


    _boundSubscribe: null,
    _boundSubmitPaymentRequest: null,
    _boundSubmitPaymentForm: null,

    onMount() {
        this.$plans = document.getElementById('Plans');
        this.$payment = document.getElementById('Payment');
        this.$processing = document.getElementById('Processing');
        this.$completed = document.getElementById('Completed');
        this.$error = document.getElementById('Error');

        this.$payment_form = document.getElementById('PaymentForm');
        this.$payment_errors = document.getElementById('PaymentErrors');

        this._boundSubscribe = this.subscribe.bind(this);
        const buttons = document.querySelectorAll('.subscribe');
        buttons.forEach(button => {
            button.addEventListener('click', this._boundSubscribe);
        });
    },
    onUnmount() {
        const buttons = document.querySelectorAll('.subscribe');
        buttons.forEach(button => {
            button.removeEventListener('click', this._boundSubscribe);
        });

        if (this.$payment_card) {
            this.$payment_card.destroy();
            this.$payment_card = null;
        }

        if (this.$payment_form && this._boundSubmitPaymentForm) {
            this.$payment_form.removeEventListener('submit', this._boundSubmitPaymentForm);
        }

        if (this.paymentRequest && this._boundSubmitPaymentRequest) {
            this.paymentRequest.off('paymentmethod', this._boundSubmitPaymentRequest);
        }
    }
};
